/* eslint-disable react/jsx-key */
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { dateCol, strCol } from '@integec/grid-tools/lib/cols'
import { hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'
import { CriteriaRow } from 'core/screen-util'
import { getApiTargetInfo, UtilityUnitSelection } from 'core'
import { connect } from 'react-redux'
import {
  getCtModalUnit,
  deleteCtModalUnit,
  updateCtModalUnit,
  getCtModal,
} from 'api/pgads.js'
import { unitIdHeader, utilityHeader } from 'core/HeaderColTypeProps'
import CommonScreen from 'admin/component/CommonScreen'
import { Button, DatePicker, Select } from 'antd'

import {
  getEnvConfig,
  getPermitActions,
  getUnitNameMap,
  getUtilityNameMap,
} from '../core/selectors'
import { ErrorContext } from 'context'
import R from 'ramda'
const headers = [
  dateCol({
    ident: 'effectiveDate',
    display: 'Effective Date',
    isKey: true,
    width: 100,
    sortOrder: 'desc',
  }),
  utilityHeader,
  unitIdHeader,
  strCol({
    ident: 'modelCode',
    display: 'Model Code',
    isKey: true,
    width: 200,
    sortOrder: 'asc',
  }),
]

const title = 'CT Model Unit'

const CtModalUnit = ({
  envConfig,
  actionPermits,
  unitNameMap,
  utilityNameMap,
  targetInfo,
}) => {
  const [insertEvent, setInsertEvent] = useState(false)
  const [modelMap, setModelMap] = useState({})
  const { setError } = useContext(ErrorContext)
  useEffect(
    _ => {
      getCtModal(targetInfo).fork(setError, data => {
        const md = R.compose(
          R.fromPairs,
          R.map(u => [u.modelCode, u.model])
        )(data)
        setModelMap(md)
      })
    },
    [targetInfo, setError]
  )

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <CriteriaRow>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '100px 200px 100px 700px',
            gap: '10px',
          }}
        >
          <div
            style={{
              display: 'grid',
              justifyContent: 'end',
              alignContent: 'center',
            }}
          >
            Effective Date :
          </div>
          <DatePicker
            style={{ minWidth: '120px' }}
            onChange={date =>
              setInsertData({
                ...insertData,
                effectiveDate: date.format('YYYY-MM-DD'),
                effectiveDate2: date,
                // transDate: date,
              })
            }
            value={insertData.effectiveDate2}
            placeholder="Effective Date"
            format="MM/DD/YYYY"
            allowClear={false}
          />
          <div
            style={{
              display: 'grid',
              justifyContent: 'end',
              alignContent: 'center',
            }}
          >
            Utility / Unit :
          </div>
          <UtilityUnitSelection
            utility={insertData.utility}
            unit={insertData.unit}
            onUnitChange={value => {
              // setUtilityUnit(value)
              setInsertData({
                ...insertData,
                utility: value[0],
                unitId: value[1],
                unit: value[1].substr(3),
              })
            }}
          />
          <div
            style={{
              display: 'grid',
              justifyContent: 'end',
              alignContent: 'center',
            }}
          >
            Modal Code :
          </div>
          <Select
            style={{ width: '100%' }}
            value={insertData.modelCode}
            onChange={value => {
              setInsertData({
                ...insertData,
                modelCode: value,
              })
            }}
          >
            {Object.keys(modelMap).map(k => (
              <Select.Option key={k} value={k}>
                {k}
              </Select.Option>
            ))}
          </Select>
          <div />
          <div
            style={{
              display: 'grid',
              // justifyContent: 'space-around',
              gridTemplateColumns: '100px 150px 150px auto',
              gap: '10px',
              width: '90%',
            }}
          >
            <Button type="primary" onClick={() => onAdd(true)}>
              Add
            </Button>
            <Button type="primary" onClick={() => onAdd(false)}>
              Add & Hide
            </Button>
            <Button type="danger" onClick={onCancel}>
              Cancel
            </Button>
          </div>
        </div>
      </CriteriaRow>
    )
  }

  const hasWritePermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.CT_INSPECTION_ADMIN],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const headerWithFormatter = headers.map(h =>
    h.ident === 'utility'
      ? {
          ...h,
          // ...toSelectionColProps(utilityNameMap),
          dataFormatter: ({ value }) => utilityNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            utilityNameMap[rowData.utility] || rowData.utility,
        }
      : h.ident === 'unitId'
      ? {
          ...h,
          choices: [],
          // dataGetter: generateDataGetter,
          dataFormatter: ({ value }) => unitNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            unitNameMap[rowData.unit] || rowData.unit,
        }
      : h
  )

  return [
    <CommonScreen
      // heightOffset={250}
      widthOffset={50}
      insertCompHeight={50}
      // totalWidth={700}
      isAdminScreen={false}
      withoutModify={!hasWritePermission}
      allowInsert={hasWritePermission}
      title={title}
      header={headerWithFormatter}
      saveTask={updateCtModalUnit}
      retrieveTask={getCtModalUnit}
      deleteTask={deleteCtModalUnit}
      altBy={d => d.unitId}
      autoRetrieve
      sortOptions={headers}
      insertComp={insertEvent && hasWritePermission && insertComp}
      onInsertEvent={b => setInsertEvent(hasWritePermission && b)}
      headerRowHeight={30}
    />,
  ]
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
  unitNameMap: getUnitNameMap(state),
  utilityNameMap: getUtilityNameMap(state),
})

export default connect(mapStateToProps)(CtModalUnit)
